//dependencies
import dropdown from "angular-ui-bootstrap/src/dropdown";
import collapse from "angular-ui-bootstrap/src/collapse";
import tabs from "angular-ui-bootstrap/src/tabs";
import ngSanitize from "angular-sanitize";

//services

//components
import customerCleanup from "emun.customer/cleanup/customer-cleanup";

export const dependencies = [dropdown, collapse, tabs, ngSanitize];

export const modules = {
  // modals,
};
//states
import states from "emun.customer/cleanup/customer-cleanup.states";

export const services = {};

export const components = {
  customerCleanup,
};

export const directives = {};

export default {
  modules,
  services,
  dependencies,
  components,
  directives,
  states
};
